// src/features/user-portfolios/utils/instrumentRoute.ts
//
// Maps a portfolio position's free-text `instrument_type` (STOCK / ETF / REIT /
// CRYPTO / COMMODITY / FX — see backend PortfolioTransaction.instrument_type)
// to its deep-dive Info Page route. All Info Pages take a `?symbol=` query
// param (see src/App.tsx). Equity/unknown is the safe default so a null or
// unexpected class still resolves to a real page.

const ROUTE_BY_TYPE: Record<string, string> = {
    STOCK: '/dashboard/stock-info-page',
    EQUITY: '/dashboard/stock-info-page',
    ETF: '/dashboard/etf-info-page',
    REIT: '/dashboard/reit-info-page',
    CRYPTO: '/dashboard/crypto-info-page',
    COMMODITY: '/dashboard/commodity-info-page',
    FX: '/dashboard/fx-info-page',
};

const DEFAULT_ROUTE = '/dashboard/stock-info-page';

/**
 * Build the deep-dive Info Page link for a portfolio symbol.
 *
 * @param symbol          The ticker (e.g. "AAPL", "BTCUSD").
 * @param instrumentType  Free-text class from the ledger (case-insensitive).
 * @returns A router path with an encoded `?symbol=` query param.
 */
export const buildInstrumentRoute = (
    symbol: string,
    instrumentType?: string | null,
): string => {
    const key = (instrumentType ?? '').trim().toUpperCase();
    const base = ROUTE_BY_TYPE[key] ?? DEFAULT_ROUTE;
    return `${base}?symbol=${encodeURIComponent((symbol ?? '').trim().toUpperCase())}`;
};

export default buildInstrumentRoute;
